/** Adds a required prefix the caller asked to keep, without doubling it. */
export function documentNameWithPrefix(name: string, prefix?: string): string {
  const trimmed = name.trim();
  const lead = prefix?.trim();
  if (!lead) return trimmed;
  if (trimmed.toLowerCase().startsWith(lead.toLowerCase())) return trimmed;
  return `${lead} ${trimmed}`.trim();
}
